export class CardData {
  public number: string;
  public cvc: string;
  public expiryMonth: string;
  public expiryYear: string;
  public holderName: string;
  public generationtime: string

  public toString(): string {
    let resp: string = '';

    resp += 'number: ' + this.number;
    resp += ', cvc: ' + this.cvc;
    resp += ', expiryMonth: ' + this.expiryMonth;
    resp += ', expiryYear: ' + this.expiryYear;
    resp += ', holderName:' + this.holderName;
    resp += ', generationtime:' + this.generationtime;

    return resp;
  }
}
